<script setup lang="ts">
    import { computed } from 'vue';
    import FormCheckable from '@shared/components/Form/FormCheckable.vue';
    import { SwitchStyle } from '@shared/components/Form/Form';
    import { STATUS_FILTERS, type StatusFilter } from './guest-list-types';

    const props = defineProps<{
        status: StatusFilter;
        requireAttestation: boolean;
        attestationPendingCount: number;
    }>();

    const disableStatusNotifications = defineModel<boolean>('disableStatusNotifications', { required: true });

    const emit = defineEmits<{
        'update:status': [status: StatusFilter];
        resendAllAttestations: [];
    }>();

    const filters = computed(() => STATUS_FILTERS.filter((f) => !f.attestationOnly || props.requireAttestation));
    const statusLabel = (status: StatusFilter) => $Resources['EventGuestList' + (status || 'All') + 'Label'];
</script>

<template>
    <div class="d-flex flex-wrap gap-lg align-items-center m-sm-b">
        <ul class="tabs-btns list-unstyled m-auto-r">
            <li v-for="filter in filters" :key="filter.status" :class="{ active: status === filter.status }">
                <a href="javascript:void(0)" @click="emit('update:status', filter.status)">{{ statusLabel(filter.status) }}</a>
            </li>
        </ul>

        <FormCheckable
            class="align-items-center"
            :label="$Resources.EventDisableGuestListNotifications"
            :switch-style="SwitchStyle.GreyToWarning"
            :checked="disableStatusNotifications"
            :infoText="$Resources.EventDisableHelpText"
            @update:modelValue="(newVal: boolean) => (disableStatusNotifications = newVal)" />

        <div v-if="requireAttestation && status === 'AttestationPending' && attestationPendingCount > 0">
            <button type="button" class="btn btn-default" @click="emit('resendAllAttestations')">
                <span class="glyphicon glyphicon-envelope m-xs-r"></span>
                {{ $Resources.EventGuestListResendAllAttestation }}
            </button>
        </div>
    </div>
</template>
